<div
  fxLayout="row wrap"
  fxLayoutGap="8px"
  fxLayoutAlign="start"
  class="u-paddingBottom-8"
>
  <a
    *ngFor="let provider of calendarProviders"
    [href]="provider.calendarUrl"
    target="_blank"
  >
    <app-chip class="u-display-block u-marginBottom-8">
      <div fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="start center">
        <div
          [ngStyle]="{ width: '18px', height: '18px' }"
          class="u-display-inlineBlock"
        >
          <img [src]="provider.logoUrl" alt="" [ngStyle]="{ width: '16px' }" />
        </div>
        <span>{{ provider.displayName }}</span>
      </div>
    </app-chip>
  </a>
  <app-chip
    *ngIf="calendarLinks.ics"
    (click)="downloadIcsForEvent(calendarLinks.ics)"
    [isClickable]="true"
    class="u-display-block u-marginBottom-8"
  >
    <div fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="start center">
      <div [ngStyle]="{ width: '18px', height: '18px' }">
        <img
          src="//storage.googleapis.com/ttc-static-images/emoji-spiral-calendar-pad.7ABA31D7.png"
          alt=""
          [ngStyle]="{ width: '16px' }"
        />
      </div>
      <span>iCalendar</span>
    </div>
  </app-chip>
</div>
